export const sanitize = {
  text: (value: string): string => {
    return value.trim().replace(/\s+/g, ' ');
  },

  phone: (value: string): string => {
    return value.replace(/[^\d()\-\s]/g, '').trim();
  },

  postalCode: (value: string): string => {
    return value
      .toUpperCase()
      .replace(/[^A-Z0-9\s]/g, '')
      .trim();
  },

  email: (value: string): string => {
    const trimmed = value.toLowerCase().trim();
    const parts = trimmed.split('@');
    if (parts.length > 2) {
      return `${parts[0]}@${parts.slice(1).join('')}`;
    }
    return trimmed;
  },

  name: (value: string): string => {
    const cleaned = value.replace(/[^a-zA-Z\s\-']/g, '');
    const trimmed = cleaned.trim().replace(/\s+/g, ' ');
    return trimmed
      .split(' ')
      .map((word) => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  },

  number: (value: string): string => {
    return value.replace(/\D/g, '');
  },

  formatPostalCode: (value: string): string => {
    const sanitized = sanitize.postalCode(value);
    if (sanitized.length === 6) {
      return `${sanitized.slice(0, 3)} ${sanitized.slice(3)}`;
    }
    return sanitized;
  },
};
